import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import moment from 'moment-timezone'
// import "moment/locale/en-gb"; // English (United Kingdom)
// import "moment/locale/en-ca"; // English (Canada)
// import "moment/locale/en-au"; // English (Australia)
// import "moment/locale/en-nz"; // English (New Zealand)
// import "moment/locale/en-in"; // English (India)
import "moment/locale/fr";    // French (default)
// import "moment/locale/fr-ca"; // French (Canada)
// import "moment/locale/fr-ch"; // French (Switzerland)
import "moment/locale/de";    // German (default)
// import "moment/locale/de-at"; // German (Austria)
// import "moment/locale/de-ch"; // German (Switzerland)
import "moment/locale/es";    // Spanish (default)
// import "moment/locale/es-mx"; // Spanish (Mexico)
import "moment/locale/it";    // Italian (default)
// import "moment/locale/it-ch"; // Italian (Switzerland)
import "moment/locale/ja";    // Japanese
import "moment/locale/ko";    // Korean
import "moment/locale/zh-cn"; // Chinese (Simplified)
import "moment/locale/zh-tw"; // Chinese (Traditional)
import "moment/locale/ru";    // Russian
import "moment/locale/ar";    // Arabic
import "moment/locale/id";    // Indonesian
import { ColumnInvoices, FormatCurrencyOptions, FormatNumberOptions, FormatTimestampOptions, InvoiceConfig } from '../../interfaces/Invoices'
import { useDraggable } from '@dnd-kit/core'
import {
  Menu,
  MenuItem,
} from '@mui/material'
import { Button as RButton } from 'react-bootstrap'
import { CSS } from '@dnd-kit/utilities'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ModeEditIcon from '@mui/icons-material/ModeEdit'
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TextFormatOutlinedIcon from '@mui/icons-material/TextFormatOutlined';
import { regexVariablesProps } from './InvoiceModal'
import { convertNumberToText, formattedCurrency } from '../../functions/general'

const X_DEBUG = false

interface DraggableItemProps {
  id: string
  routerContext: 'invoice' | 'pipeline' | 'web-view-preview'
  stepType: 'config' | 'preview'
  item: InvoiceConfig
  setItem: React.Dispatch<React.SetStateAction<InvoiceConfig>>
  handleFormDnDOpen: React.Dispatch<React.SetStateAction<void>>
  openMenuId: string | null
  setOpenMenuId: React.Dispatch<React.SetStateAction<string | null>>
  modeDnD?: 'edit' | 'preview'
  column: ColumnInvoices[]
  handleSaveFont: (id: string, font: { size: number; name: string }) => void
  handlePreviewQty: (id: string, qty: number, spacing: number) => void
  handleDeleteItem: (id: string) => void
  previewItems?: InvoiceConfig[]
}

export const DraggableItem: React.FC<DraggableItemProps> = ({
  id,
  routerContext = 'invoice',
  stepType,
  item,
  setItem,
  previewItems,
  handleFormDnDOpen,
  openMenuId,
  setOpenMenuId,
  modeDnD,
  column,
  handleSaveFont,
  handlePreviewQty,
  handleDeleteItem,
}) => {
  const [textPreview, setTextPreview] = useState<string>('')
  const [showConfig, setShowConfig] = useState<Boolean>(false)
  const [showMultiConfig, setShowMultiConfig] = useState<Boolean>(false)
  const { attributes, listeners, setNodeRef, transform } = useDraggable({ id })

  const [qty, setQty] = useState<number>(1)
  const [spacing, setSpacing] = useState<number>(1)

  const intl = useIntl()

  const style = transform
    ? {
      transform: CSS.Translate.toString(transform),
    }
    : undefined

  const AvailableCurrency = {
    IDR: { name: 'rupiah' },
    MYR: { name: 'ringgit malaysia' },
  };

  const convertToCurrencyString = (value: any, currency: 'IDR' | 'MYR') => {
    const temp = value !== null && value !== undefined ? value : 0;
    const parsedValue = parseFloat(temp.toString().replace(/[^0-9.]/g, ''));
    const result = isNaN(parsedValue) ? 0 : parsedValue;
    if (result === 0) return `${intl.formatMessage({ id: 'INVOICE.LABEL.CURRENCY_ZERO' })}`
    return `${convertNumberToText(result).split(/\s+/).join(' ').trim()} ${AvailableCurrency[currency].name}`;
  };

  const replaceFormattedContent = (type?: 'pipeline-multi-product' | 'single') => {
    const data = item.dnd_data.previewQtyHtml?.replaceAll('\n', '<br><span style="display: block; height: 5px;"></span>')
    const parsedHtml = data?.replace(/<p>(.*?)<\/p>/g, `<p style="margin-bottom:0px !important; line-height: ${item.dnd_data.font.size ? `${item.dnd_data.font.size / 1.5}px` : '8px'};">$1</p><div style="margin-top: 6px"></div>`) || ''
    const ArrayFormattedContent = [parsedHtml]
    const regex = /\[(.*?)_(.*?)\]/g

    const resultRegex = ArrayFormattedContent.flatMap((text) => {
      const matches: regexVariablesProps[] = []
      let match
      while ((match = regex.exec(text)) !== null) {
        const [fullMatch, labelName, id] = match
        matches.push({ labelName, id })
      }
      return matches
    })

    if (resultRegex.length > 0) {
      let resultVariable: ColumnInvoices[] = resultRegex
        .map((data: regexVariablesProps, index: number) => {
          const field = column.find((f) => f.label === data.labelName) as ColumnInvoices

          if (field) {
            const matchedVariable = item.dnd_data.variables?.find((v) => v.id === data.id)

            if (matchedVariable) {
              return {
                ...field,
                id: matchedVariable.id,
                type: matchedVariable.type,
                index: item.dnd_data.variables?.indexOf(matchedVariable),
                defaultValue:
                  (matchedVariable.type === 'number') && (matchedVariable.defaultValue === 0 || matchedVariable.defaultValue === '0' || matchedVariable.defaultValue === '' || matchedVariable.defaultValue === 'not_set')
                    ? '0'
                    : (matchedVariable.type === 'number') && (matchedVariable.defaultValue !== 0 || matchedVariable.defaultValue !== '0' || matchedVariable.defaultValue !== '' || matchedVariable.defaultValue !== 'not_set')
                      ? matchedVariable.defaultValue.toString().padStart((matchedVariable.format as FormatNumberOptions)?.fillDigit ?? 0, '0').slice(0, matchedVariable.format as FormatNumberOptions)?.fillDigit ?? 0
                      : (matchedVariable.type === 'currency' && (matchedVariable.format as FormatCurrencyOptions)?.currencyType === 'number') && (matchedVariable.defaultValue === 0 || matchedVariable.defaultValue === '0' || matchedVariable.defaultValue === '' || matchedVariable.defaultValue === 'not_set')
                        ? formattedCurrency((matchedVariable.format as FormatCurrencyOptions)?.locale ?? 'id-ID', (matchedVariable.format as FormatCurrencyOptions)?.currency ?? 'IDR', 0)
                        : (matchedVariable.type === 'currency' && (matchedVariable.format as FormatCurrencyOptions)?.currencyType === 'number') && (matchedVariable.defaultValue !== 0 || matchedVariable.defaultValue !== '0' || matchedVariable.defaultValue !== '' || matchedVariable.defaultValue !== 'not_set')
                          ? formattedCurrency((matchedVariable.format as FormatCurrencyOptions)?.locale ?? 'id-ID', (matchedVariable.format as FormatCurrencyOptions)?.currency ?? 'IDR', matchedVariable.defaultValue)
                          : ((matchedVariable.type === 'currency' || matchedVariable.type === 'currencyString') && (matchedVariable.format as FormatCurrencyOptions)?.currencyType === 'string') && (matchedVariable.defaultValue === 0 || matchedVariable.defaultValue === '0' || matchedVariable.defaultValue === '' || matchedVariable.defaultValue === 'not_set')
                            ? convertToCurrencyString(0, (matchedVariable.format as FormatCurrencyOptions)?.currency as 'IDR' | 'MYR' ?? 'IDR')
                            : ((matchedVariable.type === 'currency' || matchedVariable.type === 'currencyString') && (matchedVariable.format as FormatCurrencyOptions)?.currencyType === 'string') && (matchedVariable.defaultValue !== 0 || matchedVariable.defaultValue !== '0' || matchedVariable.defaultValue !== '' || matchedVariable.defaultValue !== 'not_set')
                              ? convertToCurrencyString(matchedVariable.defaultValue ?? 0, (matchedVariable.format as FormatCurrencyOptions)?.currency as 'IDR' | 'MYR' ?? 'IDR')
                              : matchedVariable.defaultValue !== undefined && matchedVariable.defaultValue !== null
                                ? matchedVariable.defaultValue
                                : '',
                format: matchedVariable.format,
              }
            } else {
              return {
                ...field,
                id: data.id,
                index: -1,
                defaultValue: '',
              }
            }
          } else {
            return null
          }
        })
        .filter(Boolean) as ColumnInvoices[]

      const replacedContent = parsedHtml.replace(regex, (match, labelName, id) => {
        const matchingVariable = resultVariable.find(
          (variable) => variable.label === labelName && variable.id === id
        )
        if (matchingVariable?.type === 'timestamp') {
          const getFormatType = ((matchingVariable.format as FormatTimestampOptions)?.format as string)
          const getFormatTimezone = ((matchingVariable.format as FormatTimestampOptions)?.timezone as string)
          const getLocale = (matchingVariable.format as FormatTimestampOptions)?.locale || 'en'; // Default ke 'en'

          const formattedTimestamp = `${moment.utc(matchingVariable.defaultValue).tz(getFormatTimezone).locale(getLocale).format(
            getFormatType ||
            'DD/MM/YYYY HH:mm'
          )}`
          return formattedTimestamp
        }
        if (matchingVariable?.type === 'number' || matchingVariable?.type === 'currency') {
          if (matchingVariable?.defaultValue === 'not_set') {
            return `<span style="color: red;">(${intl.formatMessage({ id: 'INVOICE.DEFAULT_VALUE_EMPTY' }, { title: matchingVariable.label })})<span>`
          }
        }
        return matchingVariable ? matchingVariable.defaultValue : match
      })

      setTextPreview(replacedContent)
    } else {
      setTextPreview(parsedHtml)
    }
    return void 0
  }
  useEffect(() => {
    if (item.dnd_data.formattedContent) {
      replaceFormattedContent()
      setSpacing(item.dnd_data.spacing)
    }
  }, [item, showMultiConfig, previewItems])

  return (
    <>
      {item && (
        <div
          style={{
            ...style,
            position: 'absolute',
            left: item.dnd_data.position.x,
            top: item.dnd_data.position.y,
            height: '23px',
            backgroundColor: modeDnD === 'edit' ? 'white' : undefined,
            border: modeDnD === 'edit' ? '2px solid #ccc' : undefined,
            borderRadius: modeDnD === 'edit' ? '8px' : undefined,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'baseline',
            cursor: stepType !== 'preview' ? 'grab' : 'default',
            userSelect: 'none',
            padding: '0px',
            zIndex: item.zIndex,
          }}
        >
          {modeDnD === 'edit' && (
            <>
              <div
                ref={setNodeRef}
                {...listeners}
                {...attributes}
                className='d-flex justify-content-center align-items-center'
              >
                <p className='text-nowrap' style={{ margin: 0, maxWidth: '160px', padding: '0 10px', cursor: 'grab' }}>
                  {item.name}
                </p>
              </div>
              {stepType == 'config' && (
                <div className='pe-2'>
                  <div
                    aria-label={`more-${id}`}
                    id={`menu-anchor-${id}`}
                    onClick={() => {
                      setOpenMenuId(id)
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <MoreVertIcon />
                  </div>

                  <Menu
                    id={`menu-${id}`}
                    anchorEl={document.getElementById(`menu-anchor-${id}`)}
                    open={openMenuId === id}
                    onClose={() => setOpenMenuId(null)}
                    disableScrollLock={true}
                  >
                    <MenuItem
                      onClick={() => {
                        setOpenMenuId(null)
                        setItem(item)
                        handleFormDnDOpen()
                      }}
                      data-bs-stacked-modal='#kt_modal_stacked_2'
                    >
                      <i className='fas fa-edit fs-4 me-4'></i>
                      <span>{intl.formatMessage({ id: 'FORM.ACTION.UPDATE' })}</span>
                    </MenuItem>

                    <MenuItem
                      onClick={() => {
                        setOpenMenuId(null)
                        handleDeleteItem(id)
                      }}
                    >
                      <i className='fas fa-trash fs-3 me-5'></i>
                      <span>{intl.formatMessage({ id: 'FORM.ACTION.DELETE' })}</span>
                    </MenuItem>
                  </Menu>
                </div>
              )}
            </>
          )}
          {modeDnD == 'preview' && (
            <div
              className='d-flex flex-row'
            >
              <div
                ref={stepType !== 'preview' ? setNodeRef : undefined}
                {...(stepType !== 'preview' ? listeners : {})}
                {...(stepType !== 'preview' ? attributes : {})}
                className='d-flex justify-content-center align-items-center'
                style={{
                  fontSize: item.dnd_data.font.size,
                  fontFamily: item.dnd_data.font.name,
                  textAlign: item.dnd_data.allignment,
                  transformOrigin: 'top left',
                }}
              >
                {item.dnd_data.formattedContent ? (
                  <div
                    className='m-0 z-0'
                    style={{
                      whiteSpace: 'nowrap',
                      lineHeight: '0px'
                    }}
                    dangerouslySetInnerHTML={{
                      __html: textPreview,
                    }}
                  ></div>
                ) : (
                  <p className='m-0 bg-danger text-white border border-black p-2 fw-bold'>
                    {intl.formatMessage({ id: 'FORM.VALIDATION.NO_CHOSEN' }, { title: item.name })}
                  </p>
                )}
              </div>
              {(showConfig) && (
                <div
                  className='position-absolute mt-1 me-1 bg-light d-grid gap-3'
                  style={{
                    top: item.dnd_data.position.y < 157 ? '45px' : '-160px',
                    left: item.dnd_data.position.x < 500 ? '0px' : '-120px',
                    width: '240px',
                    height: '140px',
                    padding: '5px',
                    zIndex: '1000',
                    border: '2px solid #ccc',
                    borderRadius: '5px',
                    margin: 0,
                    cursor: 'default',
                  }}
                >
                  <h5 className='text-center'>{item.name}</h5>
                  <div className='d-flex flex-row gap-2 m-0 position-relative'>
                    <label htmlFor='fontSizeSelect' className='text-nowrap ' style={{ width: '70px' }}>
                      Font Size:{' '}
                    </label>
                    <select
                      id='fontSizeSelect'
                      value={item.dnd_data.font.size}
                      className='ql-font '
                      onChange={(e) => {
                        handleSaveFont(id, {
                          size: parseInt(e.target.value),
                          name: item.dnd_data.font.name,
                        })
                      }}
                    >
                      <option value='12'>12px</option>
                      <option value='14'>14px</option>
                      <option value='15'>15px</option>
                      <option value='18'>18px</option>
                      <option value='20'>20px</option>
                      <option value='24'>24px</option>
                      <option value='32'>32px</option>
                    </select>
                  </div>
                  <div className='d-flex flex-row gap-2 m-0'>
                    <label htmlFor='fontFamilySelect' className='text-nowrap' style={{ width: '70px' }}>
                      Font Family:{' '}
                    </label>
                    <select
                      id='fontFamilySelect'
                      value={item.dnd_data.font.name}
                      onChange={(e) =>
                        handleSaveFont(id, { size: item.dnd_data.font.size, name: e.target.value })
                      }
                    >
                      <option value='Arial'>Arial</option>
                      <option value='Courier New'>Courier New</option>
                      <option value='Georgia'>Georgia</option>
                      <option value='Times New Roman'>Times New Roman</option>
                      <option value='Verdana'>Verdana</option>
                      <option value='Tahoma'>Tahoma</option>
                      <option value='Calibri'>Calibri</option>
                      <option value='Comic Sans MS'>Comic Sans MS</option>
                      <option value='Lucida Console'>Lucida Console</option>
                      <option value='Impact'>Impact</option>
                      <option value='Roboto'>Roboto</option>
                    </select>
                  </div>
                  <div className='d-flex flex-row gap-4 justify-content-center'>
                    <RButton
                      size='sm'
                      variant='secondary'
                      className='py-2'
                      onClick={() => setShowConfig(false)}
                    >
                      Close
                    </RButton>
                  </div>
                  <div style={{ height: '30px', margin: 0 }} className='bg-transparent' />
                </div>
              )}
              {(showMultiConfig) && (
                <div
                  className='position-absolute mt-1 me-1 bg-light d-grid gap-3'
                  style={{
                    top: item.dnd_data.position.y < 157 ? '45px' : '-160px',
                    left: item.dnd_data.position.x < 500 ? '0px' : '-120px',
                    width: '240px',
                    height: '160px',
                    padding: '5px',
                    zIndex: '1000',
                    border: '2px solid #ccc',
                    borderRadius: '5px',
                    margin: 0,
                    cursor: 'default',
                  }}
                >
                  <div
                  >
                    <h5 style={{
                      maxHeight: '20px',
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflowX: "hidden",
                    }} className='text-center'>
                      Edit Multiple: {item.name}
                    </h5>
                  </div>
                  <div className='d-flex flex-row gap-2 m-0 position-relative'>
                    <label htmlFor='fontSizeSelect' className='text-nowrap ' style={{ width: '140px' }}>
                      (Preview) Product QTY:{' '}
                    </label>
                    <select
                      id='fontSizeSelect'
                      value={qty}
                      className='ql-font '
                      onChange={(e) => {
                        setQty(parseInt(e.target.value))
                      }}
                    >
                      {[...Array(10).keys()].map(i => (
                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                      ))}
                    </select>
                  </div>
                  {item.model === 'pipeline-multi-product' && (
                    <div className='d-flex flex-row gap-2 m-0'>
                      <label htmlFor='fontFamilySelect' className='text-nowrap' style={{ width: '70px' }}>
                        {intl.formatMessage({ id: "FORM.LABEL.INVOICE_PRODUCT_SPACING" })}:{' '}
                      </label>
                      <div className="input-group mb-3">
                        <input
                          id='spacingSelect'
                          type="text"
                          className="form-control"
                          style={{
                            height: '24px',
                            maxWidth: '50px'
                          }}
                          placeholder="Recipient's username"
                          disabled={qty === 1 || !qty}
                          value={spacing}
                          onChange={(e) => {
                            let value = parseInt(e.target.value.replace(/[^\d]/g, ''));
                            if (value) {
                              if (value > 100) {
                                return setSpacing(100)
                              }
                              setSpacing(value);
                            } else {
                              setSpacing(0)
                            }
                          }}
                        />
                        <span className="input-group-text" id="basic-addon2" style={{
                          height: '24px',
                          maxWidth: '40px'
                        }}>px</span>
                      </div>
                    </div>
                  )}
                  <div className='d-flex flex-row gap-4 justify-content-center'>
                    <RButton
                      size='sm'
                      variant='primary'
                      className='py-2'
                      onClick={() => {
                        handlePreviewQty(id, qty ?? 1, spacing ?? 0)
                        setShowMultiConfig(false)
                      }}
                    >
                      Save
                    </RButton>
                  </div>
                  <div style={{ height: '30px', margin: 0 }} className='bg-transparent' />
                </div>
              )}
              {stepType == 'config' && (
                <div className=''>
                  <div
                    aria-label={`more-${id}`}
                    id={`menu-anchor-${id}`}
                    onClick={() => {
                      setOpenMenuId(id)
                    }}
                    className={`border ms-2 ${item.model === 'pipeline-multi-product' ? 'bg-primary text-white' : 'bg-light'}`}
                  >
                    <ModeEditIcon />
                  </div>
                  <Menu
                    id={`menu-${id}`}
                    anchorEl={document.getElementById(`menu-anchor-${id}`)}
                    open={openMenuId === id}
                    onClose={() => setOpenMenuId(null)}
                    disableScrollLock={true}
                  >
                    <MenuItem
                      onClick={() => {
                        setOpenMenuId(null)
                        setShowConfig(!showConfig);
                        setShowMultiConfig(false)
                      }}
                      data-bs-stacked-modal='#kt_modal_stacked_2'
                    >
                      <TextFormatOutlinedIcon onClick={() => { }} className='me-2' />
                      <span>Edit Font Style</span>
                    </MenuItem>

                    {item.model === 'pipeline-multi-product' && (
                      <MenuItem
                        onClick={() => {
                          setOpenMenuId(null)
                          setShowConfig(false);
                          setShowMultiConfig(!showMultiConfig)
                        }}
                      >
                        <FormatListNumberedIcon onClick={() => { }} className='me-2' />
                        <span>Edit Multi-{intl.formatMessage({ id: "MASTERS.DATATABLE.COLUMNS.PRODUCT" })}</span>
                      </MenuItem>
                    )}
                  </Menu>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  )
}
